/**
 * @file: Detection.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 农残记录信息
 */
import request from '@/utils/request'

/**
 * 添加检测记录
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectionRecordAdd(data) {
  return request({
    type: 'device',
    url: 'detection/record/add',
    method: 'post',
    data
  })
}

/**
 * 获取农残检测记录列表获取
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectionRecordListGet(data) {
  return request({
    type: 'device',
    url: 'detection/record/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取食品农残检测合格/不合格率排名（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectionRecordRankGet(data) {
  return request({
    type: 'device',
    url: 'detection/record/rank/get',
    method: 'post',
    data
  })
}

/**
 * 获取样品名称列表（ndj）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectionRecordSimplenameList(data) {
  return request({
    type: 'device',
    url: 'detection/record/simplename/list',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心-大数据分析-农残检测记录分页列表-全部导出（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectionRecordStatisticListAllExport(data) {
  return request({
    type: 'device',
    url: 'detection/record/statistic/list/all/export',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心-大数据分析-农残检测记录分页列表（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectionRecordStatisticListGet(data) {
  return request({
    type: 'device',
    url: 'detection/record/statistic/list/get',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心-大数据分析-农残检测记录分页列表-选择导出（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectionRecordStatisticListOptionalExport(data) {
  return request({
    type: 'device',
    url: 'detection/record/statistic/list/optional/export',
    method: 'post',
    data
  })
}

/**
 * 食材检测结果趋势图（ndj）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectionRecordStatisticTrendChart(data) {
  return request({
    type: 'device',
    url: 'detection/record/statistic/trend/chart',
    method: 'post',
    data
  })
}

/**
 * undefined
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function uploadPesticideResiduesData(data) {
  return request({
    type: 'device',
    url: 'upload/pesticide/residues/data',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Detection.js